import './consent_modal.less';

import React, { Component } from 'react';
import autobind from 'class-autobind';

import noop from 'lodash/noop';

import InitialConsentModal from './initial_consent_modal.jsx';

import PrivacyPreferencesModal, {
  PrivacyPreferencesModalTrigger
} from './privacy_preferences_modal.jsx';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import { OpacityTransition } from 'zoomforth_component_lib/transitions.jsx';

import { sendRequestWithPromise } from 'zoomforth_zfutils/xhr_tools.js';
import { getGenericErrorMessage } from 'zoomforth_tools/error_messaging.js';


class ConsentManagementFlow extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isPreferencesModalOpen: false,
      isConsentCookieSet: props.isConsentCookieSet,
      hasConsentedToTracking: props.hasConsentedToTracking,
      hasConsentedToAuthCookie: props.hasConsentedToAuthCookie
    };

    autobind(this);
  }

  _sendPostRequest(url) {
    return sendRequestWithPromise({
      url,
      method: 'POST',
      params: {
        route_id: this.props.routeId
      }
    });
  }

  handleAllowAllClick() {
    this._sendPostRequest('/_rpc/consent/approve_all_consent')
      .then(()=> {
        window.location.reload();
      })
      .catch(()=> {
        alert(getGenericErrorMessage());
      });
  }

  handleDeclineAllClick() {
    this._sendPostRequest('/_rpc/consent/decline_all_consent')
      .then(()=> {
        window.location.reload();
      })
      .catch(()=> {
        alert(getGenericErrorMessage());
      });
  }

  handleTrackingConsentToggle(doesConsentToTracking) {
    const url = (
      doesConsentToTracking ?
        '/_rpc/consent/approve_tracking_consent'
      :
        '/_rpc/consent/decline_tracking_consent'
    );

    this._sendPostRequest(url)
      .then(()=> {

        if (this.props.shouldUpdateTracker) {
          getTracker().updatePersistentEventData({
            should_anonymize: !doesConsentToTracking
          });
        }

        this.setState({
          isConsentCookieSet: true,
          hasConsentedToTracking: doesConsentToTracking
        });

        this.props.onConsentChange({
          isConsentCookieSet: true,
          hasConsentedToTracking: doesConsentToTracking
        });
      })
      .catch(()=> {
        alert(getGenericErrorMessage());
      });
  }

  handleAuthCookieConsentToggle(doesConsentToAuthCookie) {
    const url = (
      doesConsentToAuthCookie ?
        '/_rpc/consent/approve_auth_cookie_consent'
      :
        '/_rpc/consent/decline_auth_cookie_consent'
    );

    this._sendPostRequest(url)
      .then(()=> {
        this.setState({
          isConsentCookieSet: true,
          hasConsentedToAuthCookie: doesConsentToAuthCookie
        });

        this.props.onConsentChange({
          isConsentCookieSet: true,
          hasConsentedToAuthCookie: doesConsentToAuthCookie
        });
      })
      .catch(()=> {
        alert(getGenericErrorMessage());
      });
  }

  handleManagePreferencesClick() {
    this.setState({ isPreferencesModalOpen: true });
  }

  handleClosePreferencesClick() {
    this.setState({ isPreferencesModalOpen: false });
  }

  render() {
    const {
      isConsentRequired,
      privacyPolicyUrl
    } = this.props;

    const {
      isPreferencesModalOpen,
      isConsentCookieSet,
      hasConsentedToTracking,
      hasConsentedToAuthCookie
    } = this.state;

    if (!isConsentRequired) {
      return null;
    }

    return (
      <OpacityTransition transitionAppear={true}>
        {
          isPreferencesModalOpen ?

            <PrivacyPreferencesModal
              privacyPolicyUrl={privacyPolicyUrl}
              hasConsentedToTracking={hasConsentedToTracking}
              hasConsentedToAuthCookie={hasConsentedToAuthCookie}
              isConsentCookieSet={isConsentCookieSet}
              onAllowAllClick={this.handleAllowAllClick}
              onDeclineAllClick={this.handleDeclineAllClick}
              onTrackingConsentToggle={this.handleTrackingConsentToggle}
              onAuthCooieConsentToggle={this.handleAuthCookieConsentToggle}
              onClosePreferencesClick={this.handleClosePreferencesClick}
            />

          : isConsentCookieSet ?

            <PrivacyPreferencesModalTrigger
              privacyPolicyUrl={privacyPolicyUrl}
              onClick={this.handleManagePreferencesClick}
            />

          :

            <InitialConsentModal
              privacyPolicyUrl={privacyPolicyUrl}
              onAllowAllClick={this.handleAllowAllClick}
              onManagePreferencesClick={this.handleManagePreferencesClick}
            />
        }
      </OpacityTransition>
    );
  }

}

ConsentManagementFlow.defaultProps = {
  shouldUpdateTracker: false,
  onConsentChange: noop
};

export default ConsentManagementFlow;
